import { createContext } from "react";
import { ThreadContextData } from "./types";

export const ThreadContext = createContext({} as ThreadContextData);
